<template>
  <div>
     <div v-html="HeaderHtmlText"></div>
  </div>
</template>

<script>
export default {
  name: 'headerBackground',
  props: {
    HeaderHtmlText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>